import { FirebaseProfileRepository } from '@nx/infrastructure';
import { auth, db } from './firebase';

export const profileRepository = new FirebaseProfileRepository(db);

export function getProfileOwnerId(): string | null {
  return auth.currentUser?.uid ?? null;
}
